export const MODEL_PHASE_TYPE = {
  DRAFT: 20,
  IN_PROGRESS: 30,

  APPROVED: 50,
  PARTIALLY_PROCESSED: 60,
  IN_USE: 190,

  FULLY_PROCESSED: 70,
  CLOSED: 80,
  POSTED: 210
}
